var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTriggerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4961 10.8803C22.8016 5.31019 18.05 1 12.2918 1C6.05549 1 1 6.05549 1 12.2918C1 17.5479 4.59124 21.9652 9.45385 23.2239",
    stroke: "#313131",
    strokeWidth: 1.70973,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0338 11.2065L15.3145 25.9999L19.3316 19.8231L26.0853 16.8777L12.0338 11.2065Z",
    stroke: "#313131",
    strokeWidth: 1.70973,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriggerIcon);
export default __webpack_public_path__ + "static/media/trigger-icon.31a35993effeb5b2f1860efaabb4f105.svg";
export { ForwardRef as ReactComponent };